define('commons/pie-stats',['jquery', 'd3js', 'utils/colors', 'jquery.ui'], function($, d3, colors) {

    var PieStats = function(parentDiv, minDb, maxDb, color, slider, legend) {
    
        var parentClass = "#" + parentDiv;
        var waiting = $(parentClass + " #waiting");
        var feedback = $(parentClass + " #feedback-stats");
        var resultDiv = $(parentClass + " .resultDiv");
        var resultCanvasPop = parentClass + " .resultCanvas.population";
        var resultCanvasArea = parentClass + " .resultCanvas.area";
        var resultTextPop = $(parentClass + " .resultText.population");
        var resultTextArea = $(parentClass + " .resultText.area");
        this.margin = 0;
        this.minDb = minDb;
        this.maxDb = maxDb;
        this.slider = slider;
        this.coverage = {};
        this.init = false;
    
        var size = color.length;
        
        this.slideSensi = null;
        if (this.slider) {
            this.slideSensi = $("#slideSensi");
        }
        var width = 240 + size * 20,
            radius = width / 2;
            duration = 1200;
    
        var enterClockwise = {
            startAngle: 0,
            endAngle: 0
        };
    
        var enterAntiClockwise = {
            startAngle: Math.PI * 2,
            endAngle: Math.PI * 2
        };
    
        color.push("#FFF");
    
        var defaultD = function(value) {
            return {"value": 100 - value,
                "colorIndex": size};
        };
    
        
        var arc = [];
        for (var i = 0; i < size; i++) {
            arc.push(d3.svg.arc().outerRadius(radius - 10 + (20 * (i - size + 1))).innerRadius(radius -10 + (20 * (i -size))));
        }
        arc.push(d3.svg.arc().outerRadius(radius).innerRadius(radius));
    
        var pie = d3.layout.pie()
            .sort(null)
            .value(function(d) {
                return d.value; });
    
        var svgPop = d3.select(resultCanvasPop).append("svg")
            .attr("width", width)
            .attr("height", width);
    
        var y = d3.scale.linear()
            .domain([0, size])
            .range([70, width-70]);
    
        var svgArea = d3.select(resultCanvasArea).append("svg")
            .attr("width", width)
            .attr("height", width);
    
        var length;
        var pathPop;
        var gsPop;
        var pathArea;
        var gsArea;
        var lPop;
        var lArea;

        this.processRequest = function(coverage) {
            resultDiv.css("display", "block");
            if (coverage) {
                this.coverage = coverage;
            }
            var data = {};
            data.popValues = [];
            data.areaValues = [];
            if (this.slider) {
                var index = this.margin + "_3";
                data.popValues[0] = {value: this.coverage.popCoverage[index] ? this.coverage.popCoverage[index] * 100 : 0, colorIndex: 2};
                data.areaValues[0] = {value: this.coverage.popCoverage[index] ? this.coverage.areaCoverage[index] * 100 : 0, colorIndex: 2};
                index = this.margin + "_2";
                data.popValues[1] = {value: this.coverage.popCoverage[index] ? this.coverage.popCoverage[index] * 100 : 0, colorIndex: 1};
                data.areaValues[1] = {value: this.coverage.popCoverage[index] ? this.coverage.areaCoverage[index] * 100 : 0, colorIndex: 1};
                index = this.margin + "_1";
                data.popValues[2] = {value: this.coverage.popCoverage[index] ? this.coverage.popCoverage[index] * 100 : 0, colorIndex: 0};
                data.areaValues[2] = {value: this.coverage.popCoverage[index] ? this.coverage.areaCoverage[index] * 100 : 0, colorIndex: 0};
            } else {
                data.popValues[0] = {value: this.coverage.popProgress * 100, colorIndex: 0};
                data.areaValues[0] = {value: this.coverage.areaProgress * 100, colorIndex: 0};
            }
            
            if (!this.init) {
                this.init = true;
                 length = data.popValues.length;
                 gsPop = svgPop.append("g")
                 .attr("transform", "translate(" + width / 2 + "," + width / 2 + ")")
                 .selectAll("g").data(data.popValues).enter().append("g");
                 // set the start and end angles to 0 so we can transition
                 // clockwise to the actual values later
                 pathPop = gsPop.selectAll("path")
                     .data(function(d) { 
                         return pie([d, defaultD(d.value)]); })
                     .enter().append("path")
                     .attr("fill", function(d, i) { 
                         return color[d.data.colorIndex]; })
                     .attr("d", function(d,i) { 
                         return arc[d.data.colorIndex](enterClockwise);})
                     .each(function(d) {
                       this._current = {
                         data: d.data,
                         value: d.value,
                         startAngle: enterClockwise.startAngle,
                         endAngle: enterClockwise.endAngle
                       };
                     }); // store the initial values

                 pathPop.transition()  // update
                     .duration(duration)
                     .attrTween("d", arcTween);
                 
                 lPop = svgPop.selectAll('.legend')
                 .data(data.popValues)
                 .enter().append('g')
                 .attr('class', 'legend')
                 .attr('transform', function(d,i){ 
                     return 'translate(' + width / 2 + ',' + ( y(length - i - 1) + ((radius-70)/length)) +')';});

                 lPop.append('text')
                 .attr('x', 0)
                 .attr('y', 0)
                 .attr('class', function(d, i){return 'legend-label data-label value-' + (length - i);})
                 .attr("fill", function(d, i) { 
                     return color[d.colorIndex]; })
                 .text(function(d) { 
                     return 0 + '%'; })
                 .transition()
                 .duration(duration)
                 .tween("text", valueTween);
                 
                 lPop.append('text')
                 .attr('x', 0)
                 .attr('y', 10)
                 .attr('class', function(d, i){return 'legend-label units-label value-' + (length - i);})
                 .attr("fill", function(d, i) { 
                         return color[d.colorIndex]; })
                 .text(function(d, i) { return legend[length - i - 1]; });

                 length = data.areaValues.length;
                 gsArea = svgArea.append("g")
                     .attr("transform", "translate(" + width / 2 + "," + width / 2 + ")")
                     .selectAll("g").data(data.areaValues).enter().append("g");
                 // set the start and end angles to 0 so we can transition
                 // clockwise to the actual values later
                 pathArea = gsArea.selectAll("path")
                     .data(function(d) { 
                         return pie([d, defaultD(d.value)]); })
                     .enter().append("path")
                     .attr("fill", function(d, i) { 
                         return color[d.data.colorIndex]; })
                     .attr("d", function(d,i) { 
                         return arc[d.data.colorIndex](enterClockwise);})
                     .each(function(d) {
                       this._current = {
                         data: d.data,
                         value: d.value,
                         startAngle: enterClockwise.startAngle,
                         endAngle: enterClockwise.endAngle
                       };
                     }); // store the initial values

                 pathArea.transition()  // update
                     .duration(duration)
                     .attrTween("d", arcTween);

                 lArea = svgArea.selectAll('.legend')
                 .data(data.areaValues)
                 .enter().append('g')
                 .attr('class', 'legend')
                 .attr('transform', function(d,i){ 
                     return 'translate(' + width / 2 + ',' + ( y(length - i - 1) + ((radius-70)/length)) +')';});

                 lArea.append('text')
                 .attr('x', 0)
                 .attr('y', 0)
                 .attr('class', function(d, i){return 'legend-label data-label value-' + (length - i);})
                 .attr("fill", function(d, i) { 
                         return color[d.colorIndex]; })
                 .text(function(d) { 
                     return 0 + '%'; })
                 .transition()
                 .duration(duration)
                 .tween("text", valueTween);
                 
                 lArea.append('text')
                 .attr('x', 0)
                 .attr('y', 10)
                 .attr('class', function(d, i){return 'legend-label units-label value-' + (length - i);})
                 .attr("fill", function(d, i) { 
                         return color[d.colorIndex]; })
                 .text(function(d, i) { return legend[length - i - 1]; });
            } else {
                length = data.popValues.length;
                gsPop = gsPop.data(data.popValues);
                pathPop = pathPop.data(function(d) { 
                    return pie([d, defaultD(d.value)]); }); // update the data

                pathPop.transition().duration(duration).attrTween("d", arcTween); // redraw the arcs
                
                lPop = lPop.data(data.popValues);

                lPop.selectAll("text.data-label").data(function (d, i) {return d;});
                lPop.select("text.data-label").transition()
                    .duration(duration)
                    .tween("text", valueTween);

                length = data.areaValues.length;
                gsArea = gsArea.data(data.areaValues);
                pathArea = pathArea.data(function(d) { 
                    return pie([d, defaultD(d.value)]); });

                pathArea.transition().duration(duration).attrTween("d", arcTween); // redraw the arcs
                
                lArea = lArea.data(data.areaValues);

                lArea.selectAll("text.data-label").data(function (d, i) {return d;});
                lArea.select("text.data-label").transition()
                    .duration(duration)
                    .tween("text", valueTween);
            }

            resultTextPop.text("Population data");
            resultTextArea.text("Area data");
        
        };
        
        // Store the displayed angles in _current.
        // Then, interpolate from _current to the new angles.
        // During the transition, _current is updated in-place by d3.interpolate.
        function arcTween(a, index) {
            var i = d3.interpolate(this._current, a);
            this._current = i(0);
            return function(t) {
                var loc = i(t);
                // to prevent arcs to flash
                if (loc.endAngle < 0.00001) {
                    loc.endAngle = 0;
                }
                if (loc.endAngle < 0) {
                    loc.endAngle = 0;
                }
                return arc[a.data.colorIndex](loc);
            };
        }
        
        function valueTween(a) {
            var i = d3.interpolate(this.textContent.substring(0,this.textContent.indexOf("%")), a.value);
    
            return function(t) {
                if (i(t) < 0) {
                    this.textContent = "N/A";
                } else {
                    this.textContent = i(t).toFixed(1) + '%';
                }
            };
        }

        if (this.slider) {
            this.colorSensi = function(value) {
                return colors.sensiToRGB(value, 0, this.maxDb - this.minDb);
            };

            this.doUpdate =  $.proxy(function(event, ui) {
                if (ui && ui.value >= 0) {
                    this.margin = parseInt(ui.value) ;
                }
                this.processRequest();
            }, this);

            this.doSlide =  $.proxy(function(event, ui) {
                var value = this.margin;
                if (ui && ui.value >= 0) {
                    value = parseInt(ui.value);
                }
                $("#slideSensi").css('background', this.colorSensi(value));
                var target = $("#slideSensi span.ui-slider-handle");
                var tooltip = '<div class="tooltip"><div class="tooltip-inner">' + value + '</div><div class="tooltip-arrow"></div></div>';
                $(target).html(tooltip);
            }, this);

            this.slideSensi.slider({
                change: this.doUpdate,
                slide: this.doSlide,
                min: 0,
                max: this.maxDb - this.minDb,
                value: 0
            });
            this.doSlide();
        }
    };
    
    PieStats.prototype.changeSourceId = function(data, minDb, maxDb) {
        this.processRequest(data);
        if (this.slider) {
            this.margin = 0;
            this.minDb = minDb;
            this.maxDb = maxDb;
            this.slideSensi.slider("value", minDb);
            this.doSlide();
        }
    };

    return PieStats;
});
